import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { formatDistanceToNow } from 'date-fns';

import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import { TimeAndDateService } from 'app/services/time-and-date-service';
import { FlightMapComponent } from "../../flight/flight-map/flight-map.component";
import { FlightOptionService } from 'app/services/flight-option-service';
import { normalizeBooleanFlag } from 'app/utils/boolean-normalizer';

@Component({
  selector: 'app-watcher-card',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent, FlightMapComponent],
  templateUrl: './watcher-card.component.html',
  styleUrl: './watcher-card.component.scss'
})
export class WatcherCardComponent implements OnChanges {
  @ViewChild('menu') menu!: ElementRef;
  @Input() watcher: any;
  @Input() persistent: boolean = false;
  @Input() allowPreviewMenu: boolean = false;
  @Input() previewMenuRemoveLabel: string = 'Remove from List';
  @Output() handleViewOptionsClick = new EventEmitter;
  @Output() handleTogglePrivacy = new EventEmitter;
  @Output() handleDeleteWatcher = new EventEmitter;
  @Output() handleToggleStatus = new EventEmitter;
  createdAt: string = '';
  checkedAt: string = '';
  flightOptionData: any;
  showMenu: boolean = false;
  menuListener: any;
  restrictionBadges: string[] = [];


  constructor(private timeAndDate: TimeAndDateService, private flightOptionService: FlightOptionService, private renderer: Renderer2) { }

  ngOnChanges(_changes: SimpleChanges): void {
    this.updateRestrictionBadges();
  }

  ngOnInit() {
    this.updateRestrictionBadges();
    if (!this.persistent) {
      this.getFlightOptionData();
      const jsCreatedAt = this.timeAndDate.firestoreTimestampToDate(this.watcher.createdAt);
      const timeAgo = formatDistanceToNow(jsCreatedAt, { addSuffix: true });
      this.createdAt = timeAgo;

      if (this.watcher.checkedAt) {
        const jsCheckedAt = this.timeAndDate.firestoreTimestampToDate(this.watcher.checkedAt);
        const timeUntil = formatDistanceToNow(jsCheckedAt, { addSuffix: true });
        this.checkedAt = timeUntil;
      }
    }
  }

  async getFlightOptionData() {
    const flightData = await this.flightOptionService.getFlightOption(this.watcher.flightOptionId);
    if (flightData) {
      this.flightOptionData = flightData;
      this.updateRestrictionBadges();
    }
  }

  private updateRestrictionBadges(): void {
    const restrictions = new Set<string>();
    const sources = [this.watcher, this.flightOptionData];

    sources.forEach(source => {
      if (!source) {
        return;
      }

      const childrenAllowed = normalizeBooleanFlag(source.isChildrenOk);
      if (childrenAllowed === false) {
        restrictions.add('No Children');
      }

      const petsAllowed = normalizeBooleanFlag(source.isPetOk);
      if (petsAllowed === false) {
        restrictions.add('No Pets');
      }
    });

    this.restrictionBadges = Array.from(restrictions);
  }

  onShowMenu() {
    if (!this.showMenu) {
      setTimeout(() => {
        this.menuListener = this.renderer.listen('document', 'click', (e: Event) => {
          if (!this.menu.nativeElement.contains(e.target)) {
            this.showMenu = false;
            this.menuListener?.(); // cleanup
          }
        });
      }, 10);
      this.showMenu = true;
    } else {
      this.showMenu = false;
      this.menuListener?.();
    }
  }

  d(date): string {
    return this.timeAndDate.formatDateToMMDDYY(date);
  }

  onClickViewOptions() {
    this.handleViewOptionsClick.emit();
  }

  onClickTogglePrivacy() {
    this.handleTogglePrivacy.emit(this.flightOptionData);
  }

  onClickDelete(watcher) {
    this.handleDeleteWatcher.emit(watcher);
  }

  onClickToggleStatus() {
    this.handleToggleStatus.emit(this.watcher);
  }

}
